import {apiUrl} from "../../components/common/getEnv";

export const fetchDetailUrl = (categoryId) => `${apiUrl}/details?category_id[]=${categoryId}&scope=listable`;